export const ufiGenericaDenunciaConfig = [
  {
    path: "/actuaciones/new/ufi-generica-denuncia/initial",
    pathName: "ufi-generica-denuncia",
    titulo: "UFI - DELITOS GENÉRICOS POR DENUNCIA",
    icon: "pi-building",
    roles: [
      "User Tester",
      "Super User",
      "Jefe de Dependencia",
      "Oficial Sumariante",
      "Jefe de Sumario",
    ],
    type: "link",
    grupo: "UFI",
    props: { formType: "ufi-generica", actuacionType: "ufi-generica-denuncia" },
    nameOfRoute: "actuacion-initial",
  },
  {
    path: "/actuaciones/new/ufi-generica-denuncia/initial/denunciante",
    pathName: "ufi-generica-denuncia",
    titulo: "AFECTADOS",
    nameOfRoute: "actuacion-form-denunciante",
  },
  {
    path: "/actuaciones/new/ufi-generica-denuncia/initial/momento",
    pathName: "ufi-generica-denuncia",
    titulo: "FECHA, HORA y UBICACIÓN",
    nameOfRoute: "actuacion-form-momento",
  },
  {
    path: "/actuaciones/new/ufi-generica-denuncia/initial/acusado",
    pathName: "ufi-generica-denuncia",
    titulo: "VINCULADOS",
    nameOfRoute: "actuacion-form-acusado",
  },
  {
    path: "/actuaciones/new/ufi-generica-denuncia/initial/efectos",
    pathName: "ufi-generica-denuncia",
    titulo: "EFECTOS",
    nameOfRoute: "actuacion-form-efectos",
  },
];
